/**
 * Chart colours derived from the openr brand palette and validated with the dataviz checker
 * (lightness band, chroma floor, CVD separation, contrast) on the salt card surface.
 * Order is fixed: a series keeps its colour whatever the filter does.
 */
export const SERIES = ['#5146c1', '#0f9ea1', '#b7801a', '#b06bb0', '#cf5d35'] as const;

export const SEQUENTIAL = ['#d7d6e7', '#a9a5d4', '#7d75c4', '#5146c1', '#312783'] as const;

export const STATUS = {
  ok: '#158252',
  warning: '#cd4111',
  error: '#c82b49',
  unknown: '#6a6a6a',
} as const;

export const INK = {
  primary: '#242424',
  secondary: '#6a6a6a',
  muted: '#c8c8c8',
  grid: '#eae9f2',
  surface: '#ffffff',
} as const;

export const seriesColour = (index: number): string => SERIES[Math.min(index, SERIES.length - 1)];
